import { API, apiRequest } from './api';
import { ApiError } from './errors';

// Save survey responses
// Expects a JWT token for auth and a JSON-serializable body
export async function saveResponses(data, token) {
  token = token || localStorage.getItem('token');
  if (!token) throw new Error('Authentication token is required.');

  try {
    const response = await apiRequest(API.SAVE_RESPONSES, {
      method: 'POST',
      token,
      body: data,
    });

    const contentType = response.headers.get('Content-Type') || '';
    if (contentType.includes('application/json')) {
      return await response.json();
    }
    const text = await response.text().catch(() => '');
    return text ? { message: text } : {};
  } catch (error) {
    console.error('Error saving survey responses:', error);
    if (error?.name === 'ApiError')
      throw new ApiError('surveySave', error.status);
    throw error;
  }
}

// Post an anonymous survey and receive a temporary claim (public endpoint)
export async function postAnonSurvey(data) {
  try {
    const response = await apiRequest(API.ANON_SURVEY, {
      method: 'POST',
      body: data,
    });
    const json = await response.json();
    return json;
  } catch (error) {
    console.error('Error posting anon survey:', error);
    if (error?.name === 'ApiError')
      throw new ApiError('anonSurvey', error.status);
    throw error;
  }
}

// Fetch anon brief by claimCode (public)
export async function getAnonBrief(claimCode) {
  try {
    const url = `${API.ANON_SURVEY_BRIEF}?claimCode=${encodeURIComponent(
      claimCode,
    )}`;
    const response = await apiRequest(url, { method: 'GET' });
    return response.json();
  } catch (error) {
    console.error('Error fetching anon brief:', error);
    if (error?.name === 'ApiError')
      throw new ApiError('anonSurvey', error.status);
    throw error;
  }
}

// Claim a previously-created anonymous result and attach it to the authenticated user
export async function claimAnonSurvey(claimId, claimCode, token) {
  if (!token)
    throw new Error('Authentication token is required to claim a survey.');
  try {
    const response = await apiRequest(API.CLAIM, {
      method: 'POST',
      token,
      body: { claimId, claimCode },
    });
    return response.json();
  } catch (error) {
    console.error('Error claiming anon survey:', error);
    if (error?.name === 'ApiError') throw new ApiError('claim', error.status);
    throw error;
  }
}
